import { useSelector } from "react-redux";

const COUNTRY_FIELD_NAME = "country";

const normalizeCountryCode = (value) => {
  if (typeof value !== "string") return null;
  const normalized = value.trim().toUpperCase();
  return /^[A-Z]{2}$/.test(normalized) ? normalized : null;
};

export const useDefaultPhoneCountry = () => {
  const billingCountry = useSelector((state) => state.payData?.country);
  const customerCountry = useSelector(
    (state) => state.profileInfo?.customer?.country,
  );
  const isGatewayCountryField = useSelector((state) =>
    (state.currentGateway?.additional_fields || []).some(
      (field) => field?.name === COUNTRY_FIELD_NAME,
    ),
  );

  return (
    (!isGatewayCountryField && normalizeCountryCode(billingCountry)) ||
    normalizeCountryCode(customerCountry)
  );
};
